import React, { useState } from "react";
import SearchInputBox from "Components/common/SearchInputBox";

const SEARCH_VISIBLE_THRESHOLD = 8;
const LIMITED_ROWS_COUNT = 2;

const SelectedLiAccountList = (props = {}) => {
  const {
    accounts = [],
    loading = false,
    canRemove = true,
    onRemove = () => {},
    showLimit = false
  } = props || {};

  const [showMore, setShowMore] = useState(true);
  const [searchText, setSearchText] = useState("");

  if (loading) {
    return (
      <div className="selectedInboxListV2">
        <ul className="inboxRowList">
          {Array.from({ length: 4 }, (value, index) => (
            <li key={`liAccountRowLoader-${index}`} className="linear-background" />
          ))}
        </ul>
      </div>
    );
  }

  if (!accounts?.length) {
    return <></>;
  }

  const showSearch = !showLimit && accounts?.length > SEARCH_VISIBLE_THRESHOLD;
  const filteredAccounts =
    showSearch && searchText
      ? accounts.filter(item =>
          item?.label?.toLowerCase()?.includes(searchText.toLowerCase())
        )
      : accounts;
  const visibleAccounts =
    showLimit && showMore
      ? filteredAccounts.slice(0, LIMITED_ROWS_COUNT)
      : filteredAccounts;
  const hiddenCount = filteredAccounts.length - LIMITED_ROWS_COUNT;

  return (
    <div className={`selectedInboxListV2 ${showLimit ? "limitedList" : ""}`}>
      {showSearch && (
        <div className="listSearchWrapper">
          <SearchInputBox
            placeholder="Search connected LinkedIn accounts"
            valueCbk={setSearchText}
            hasCloseIcon={true}
            hasSearchIcon={false}
            hideFocus={true}
          />
        </div>
      )}
      <ul className="inboxRowList">
        {visibleAccounts.map((item = {}) => (
          <li className="inboxRow" key={`selectedLi${item?.id}`}>
            <span className="rowEmail" title={item?.label}>
              {item?.label}
            </span>
            {item?.isPremium && (
              <span className="rowBadges">
                <span className="statsBadge activeBadge">Sales Navigator</span>
              </span>
            )}
            <button
              type="button"
              className={`rowRemoveBtn ${canRemove ? "" : "disabled"}`}
              title={
                canRemove
                  ? "Remove LinkedIn account from sequence"
                  : "At least one LinkedIn account must remain connected"
              }
              onClick={
                canRemove ? () => onRemove(item?.id) : () => {}
              }
            >
              <i className="material-icons">close</i>
            </button>
          </li>
        ))}
        {showSearch && filteredAccounts.length === 0 && (
          <li className="noResultRow">No LinkedIn accounts match your search</li>
        )}
      </ul>
      {showLimit && filteredAccounts.length > LIMITED_ROWS_COUNT && (
        <div className="viewMoreBtn" onClick={() => setShowMore(!showMore)}>
          <span>{showMore ? `View ${hiddenCount} more` : "View less"}</span>
          <i className="material-icons arrowDownIcon">
            {showMore ? "keyboard_arrow_down" : "keyboard_arrow_up"}
          </i>
        </div>
      )}
    </div>
  );
};

export default SelectedLiAccountList;
